module.exports = __webpack_public_path__ + "static/img/IMG_20170906_111353.a45e2ab8.jpg";